import styled from 'styled-components';

export const SchedulerAdditionalFieldsStyles = styled.div`
  position: relative;
  .back-btn{
    cursor: pointer;
      height: 1.5rem;
      margin: 0;
      padding: 0;
      position: absolute;
      left: 20px;
      top: 20px;
      width: 1.5rem;
      z-index: 3;

      ${props => props.theme.media.lg} {
        left: 50px;
        top: 50px;
      }
  }
  ${props => props.theme.media.md} {  
    label .label-text {
      font-size: 18px;
      font-height: 21px;
      color: #707070;
      margin-left: 10px;
      margin-top: 5px;
      font-family: Inter;
    }
    .input-wrap {
      .select-options {
        top: calc(3em + 0.75rem + 2px);
      }
      input:not([type=checkbox]).form-control, select.form-control {
        height: 3.8rem !important;
        padding-left: 1rem !important;
      }
    } 
    .form-wrap {
      .btn-submit {
        width: auto;
        margin-top: 3rem;
        padding 1.3rem 5.5rem;
        font-size: 1.5rem;
      }
    } 
  }  
  label .label-text {
    color: #5F5F5F;
  }
  
  

  .questions {
    padding-bottom: 60px;
  
    .title {
      margin: 0 auto 2rem;
      font-size: 1.5rem;
      font-weight: 300;
      text-align: center;
      font-family: "Inter";
       color: #5F5F5F;
      ${props => props.theme.media.md} {
        font-size: 38px;
        line-height: 47px;
        font-weight: 200;
      }
    }

    .subtitle {
      font-weight: 500;
      margin: 0 auto 1rem;
      text-align: center;

      ${props => props.theme.media.lg} {
      }
    }

    .form-title {
      margin: 0 auto 1rem;
      text-align: center;
      width: 80%;

      ${props => props.theme.media.lg} {
        margin: 1rem auto;
        width: 40%;
      }
    }

    .form-wrap {
      max-width: 942px;
      margin: 0 auto;
      
      
 .form-background{
  background-color: #3F5261;
  padding: 18px 20px 48px;
  border-radius: 15px;

  ${props => props.theme.media.lg} {
    padding: 18px 56px 48px;
  }
 }
 .schedule-time{
   color: white;
   font-weight: 300;
   font-size:18px;
   font-family: Inter;
   margin-bottom: 20px;
 }
 .btn-submit {
   margin-top: 2px;
   height: 52px;
   font-family: Poppins; 
   font-size: 22px;
   
   ${props => props.theme.media.lg} {
     margin-top: 19px;

   }
 }
      .form-control {
        border-radius: 0.25rem;
        font-size: 1rem;
        height: 3.5rem;
        padding: 0.5rem;
        border-width: 4px;
      }
      .select-options {
        .form-control {
          height: 1.75rem;
          font-size: 1rem;
          padding 0 30px 0 36px;
        }
      }
      
      form {
        display: flex;
        flex-direction: column;

        .input-wrap {
          margin-bottom: 0.5rem;
          position: relative;

          .tooltip-container {
            position: absolute;
            right: -2rem;
            top: 0.5rem;
            ${props => props.theme.media.md} { 
              top: 1.1rem;
            }
            
          }

          &.has-info {
            width: calc(100% - 2rem);

            ${props => props.theme.media.md} {
              width: 100%;
            }
          }
        }
      }
    }
  }

  .terms-text {
    margin-top: 2rem;
    text-align: left;
    font-size: 16px;
    line-height: 22px;
    font-weight: 300;
    font-family: Inter;
    font-size: 14px;
  }

  .loading-message {
    margin-top: 20%;
    position: absolute;
    top: 120px;
    z-index: 999;
    text-align: center;
    left: 50%;
    transform: translateX(-50%);
    max-width: 29em;
  }

  ${props => props.theme.media.md} {
    .loading-message {
      margin-top: 12%;
      top: 200px
    }
  }

  .is-loading:before {
    top: -118px;
    height: 800px;
  }

  .invalid-feedback {
    color: white;
  }

  .hidden {
    visibility: hidden;
  }
`;
